import React from 'react'
import { AdminContext, AdminProps, defaultI18nProvider, localStorageStore } from 'react-admin'
import { PermissionContextProvider } from '../../contexts/rbac-context'
import { UserContextProvider } from '../../contexts/user-context'
import { ScrollToTopButton } from '../buttons'
import { RbacAdminUI } from './RbacAdminUI'

export const RbacAdmin: React.FC<AdminProps> = (props) => {
  const {
    authProvider,
    basename,
    catchAll,
    children,
    dashboard,
    dataProvider,
    disableTelemetry,
    history,
    i18nProvider = defaultI18nProvider,
    layout,
    loading,
    loginPage,
    menu, // deprecated, use a custom layout instead
    notification,
    queryClient,
    requireAuth,
    store = localStorageStore(),
    ready,
    theme,
    title = 'React Admin',
  } = props

  return (
    <AdminContext
      authProvider={authProvider}
      basename={basename}
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      store={store}
      history={history}
      queryClient={queryClient}
      theme={theme}
    >
      <UserContextProvider>
        <PermissionContextProvider>
          <RbacAdminUI
            layout={layout}
            dashboard={dashboard}
            disableTelemetry={disableTelemetry}
            menu={menu}
            catchAll={catchAll}
            title={title}
            loading={loading}
            loginPage={loginPage}
            notification={notification}
            requireAuth={requireAuth}
            ready={ready}
          >
            {children}
          </RbacAdminUI>
          <ScrollToTopButton />
        </PermissionContextProvider>
      </UserContextProvider>
    </AdminContext>
  )
}
